import { useCallback } from 'react'

export type OpenEmailComposeOptions = {
  subject?: string
  body?: string
}

const buildMailtoUrl = (
  email: string,
  subject?: string,
  body?: string,
): string => {
  const params = new URLSearchParams()
  if (subject) {
    params.set('subject', subject)
  }
  if (body) {
    params.set('body', body)
  }
  const query = params.toString()
  return query
    ? `mailto:${encodeURIComponent(email)}?${query}`
    : `mailto:${encodeURIComponent(email)}`
}

/**
 * Returns a function that opens the default email client with a mailto link.
 * No-op when email is missing or in SSR (window undefined).
 */
export function useOpenEmailCompose(): (
  email: string | undefined,
  options?: OpenEmailComposeOptions,
) => void {
  return useCallback(
    (email: string | undefined, options?: OpenEmailComposeOptions) => {
      if (typeof window === 'undefined' || !email?.trim()) {
        return
      }
      const url = buildMailtoUrl(
        email.trim(),
        options?.subject,
        options?.body,
      )
      window.location.href = url
    },
    [],
  )
}
